import { Injectable } from "@angular/core";
import { Observable, of, throwError } from "rxjs";
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { catchError, map, tap } from 'rxjs/operators';
import { AppConfig } from "src/app/config";


@Injectable({
    providedIn: 'root'
})
export class APIService {

    constructor(private _http: HttpClient) {
    }

    baseUrl: string = AppConfig.API_BASE_URL;
    cccUrl: string = AppConfig.CCC_BASE_URL;

    get(url: string): Observable<any> {
        return this._http.get(this.baseUrl + url, this.getHeaders())
            .pipe(
                catchError((error: HttpErrorResponse) => {
                    this.handleError<any>('get', error);
                    return throwError(() => error);
                })
            );
    }
    fetch(url: string): Observable<any> {
        return this._http.get(this.cccUrl + url)
            .pipe(
                catchError((error: HttpErrorResponse) => {
                    this.handleError<any>('get', error);
                    return throwError(() => error);
                })
            );
    }
    getBlob(url: string) {
        this._http.get(this.baseUrl + url, { responseType: 'blob' })
            .subscribe((result: Blob) => {
                const blob = new Blob([result], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64," }); // you can change the type
                const url = window.URL.createObjectURL(blob);
                window.open(url);
            });
    }
     post(record: any, url: string, headers?: any): Observable<any> {
        return this._http.post(this.baseUrl + url, record, this.getHeaders(headers));
    }

    postFormData(record: FormData, url: string, headers?: any): Observable<any> {
        return this._http.post(this.baseUrl + url, record, this.getFormDataHeaders(headers));
    }
     put(record: any, url: string): Observable<any> {
        return this._http.put(this.baseUrl + url, record, this.getHeaders());
    }
    delete(id: number,url: string): Observable<any> {
        return this._http.delete(`${this.baseUrl}${url}`, this.getHeaders()).pipe(
            catchError(this.handleError<any>('delete'))
        );
    }
    deleteById(id: number, url: string): Observable<any> {

        return this._http.delete(`${this.baseUrl}${url}/${id}`, this.getHeaders()).pipe(
            catchError(this.handleError<any>('delete'))
        );
    }
    private getHeaders(headers?: any) {
        return {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',                
                'Access-Control-Allow-Origin': 'token, XSRF-TOKEN, x-xsrf-token, isOngoingCall, emailId, userId, elevatorId, x-ms-request-id, x-ms-request-root-id, incidentId, Origin, X-Requested-With, Content-Type, Accept',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, PATCH, DELETE',
            }),
            withCredentials: true,
            observe: 'response' as 'response'
        };
    }
    private getFormDataHeaders(headers?: any) {
        return {
            headers: new HttpHeaders({                
                'Access-Control-Allow-Origin': 'token, XSRF-TOKEN, x-xsrf-token, isOngoingCall, emailId, userId, elevatorId, x-ms-request-id, x-ms-request-root-id, incidentId, Origin, X-Requested-With, Content-Type, Accept',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, PATCH, DELETE',
                'access-control-allow-headers':'token, XSRF-TOKEN, isOngoingCall, emailId, userId, elevatorId, incidentId, Origin, x-ms-request-id, x-ms-request-root-id, X-Requested-With, Content-Type, Accept',
                ...headers
            }),
            withCredentials: true,
            observe: 'response' as 'response',
        }
    }
    /** Log a HeroService message with the MessageService */
    private log(message: string) {
        //this.debugService.add(`DataService: ${message}`);
    }

    /**
     * Handle Http operation that failed.
     * Let the app continue.
     * @param operation - name of the operation that failed
     * @param result - optional value to return as the observable result
     */
    private handleError<T>(operation = 'operation', result?: T) {
        //
        return (error: any): Observable<T> => {
            // TODO: send the error to remote logging infrastructure
            console.error("error",error); // log to console instead
            // TODO: better job of transforming error for user consumption
            this.log(`${operation} failed: ${error.message}`);
            // Let the app keep running by returning an empty result.
            return of(error);
        };
    }
}
